import React from 'react';
import styles from './index.module.scss';

const Message = ({ className }) => {
    return (
        <svg
            id='Group_9349'
            data-name='Group 9349'
            xmlns='http://www.w3.org/2000/svg'
            width='94'
            height='94'
            viewBox='0 0 94 94'
            className={className}
        >
            <circle
                id='Ellipse_115'
                data-name='Ellipse 115'
                cx='47'
                cy='47'
                r='47'
                className={styles.circle}
            />
            <g id='Group_3361' data-name='Group 3361' transform='translate(-167.531 -419)'>
                <path
                    id='Subtraction_5'
                    data-name='Subtraction 5'
                    d='M5.922,40H5.874C2.67,40,.039,37.049.009,33.421s-.01-7.342,0-10.5V6.759c-.024-3.376,2-6.129,4.912-6.7A5.1,5.1,0,0,1,5.766,0H44.184c3.032,0,5.615,2.71,5.762,6.041.063,1.611.059,3.251.049,4.836v.234c0,.628-.01,1.257-.01,1.884v14.16c0,.559,0,1.117,0,1.674v.649c0,1.3,0,2.641-.02,3.958-.024,3.672-2.637,6.55-5.937,6.55q-3.984-.008-7.974-.007l-7.666,0h-.308q-3.984,0-7.969,0c-1.426,0-2.842,0-4.268-.009s-2.852-.007-4.272-.007C9.4,39.969,7.6,39.979,5.922,40ZM30.937,21.915a.407.407,0,0,1,.229.087c.039.031.063.048.088.067q6.687,5.609,13.379,11.215c.381.32.7.585,1.03.838l.029-.046q-1.062-1.249-2.124-2.508-.806-.951-1.606-1.9l-.4-.471q-4.006-4.725-8.018-9.461c5.864-5.214,10.376-9.219,14.644-12.995l-.029-.06c-.039.023-.078.042-.117.063a1.638,1.638,0,0,0-.21.117c-1.162.724-2.334,1.45-3.5,2.178l-.029.015q-2.109,1.313-4.219,2.624-3.721,2.308-7.441,4.624l-1.982,1.234q-2.732,1.7-5.464,3.4a.432.432,0,0,1-.2.044.424.424,0,0,1-.22-.058c-4.15-2.566-8.564-5.308-13.115-8.15-2.91-1.8-6-3.719-9.429-5.862l-.161-.09-.166-.09L1.874,6.8q3.494,3.108,7,6.215l1.055.935,1.943,1.727Q14.16,17.7,16.45,19.738q-2.908,3.434-5.806,6.848-3.149,3.728-6.309,7.448a.557.557,0,0,0,.283-.134L5.9,32.826q6.438-5.384,12.861-10.771a1.12,1.12,0,0,1,.122-.09.37.37,0,0,1,.181-.058.462.462,0,0,1,.283.134l1.572,1.214c.508.389,1.006.779,1.514,1.168q1.15.886,2.3,1.775a.427.427,0,0,0,.269.122.453.453,0,0,0,.273-.122c.664-.522,1.333-1.037,2-1.553l.254-.2.088-.066c.986-.761,2.012-1.551,3.013-2.34A.527.527,0,0,1,30.937,21.915Z'
                    transform='translate(189.531 446)'
                    className={styles.icon}
                    stroke='rgba(0,0,0,0)'
                    stroke-width='1'
                />
            </g>
        </svg>
    );
};

export default Message;
